// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link[data-v-8c65e4fc]{color:rgba(77,77,77,.55);font-size:14px;line-height:1.2;text-decoration:none;letter-spacing:.2px}.link+.link[data-v-8c65e4fc]{margin-left:5px}.link+.link[data-v-8c65e4fc]:before{content:\"/\";margin-right:4px}", ""]);
// Exports
module.exports = exports;
